import DailySalesManagementPage from './DailySalesManagementPage';

export default DailySalesManagementPage;
